export const data = {
    companyPhone: "13304519909 / 18504512070"
};
